import React, { memo, useCallback, useMemo } from 'react';
import { downloadItem } from 'reactApp/appHelpers/appHelpers';
import { isViewContentOnly } from 'reactApp/appHelpers/settingsHelpers';
import { isArchive, isPreviewable } from 'reactApp/modules/file/utils';
import { CloudItem, EStorageType } from 'reactApp/modules/storage/storage.types';
import { MobileViewerItem } from 'reactApp/ui/Mobile/MobileViewer/MobileViewerItem/MobileViewerItem';
import { ViewerArchiveConnected } from 'reactApp/ui/ReactViewer/ViewerArchive/ViewerArchive';
import { sendXray } from 'reactApp/utils/ga';

import styles from './PublicFile.css';

interface IProps {
    file: CloudItem;
    storage: EStorageType;
}

export const PublicFile = memo<IProps>(({ file, storage }) => {
    const isPreviewableFile = isPreviewable(file);

    const handleDownload = useCallback(() => {
        downloadItem({ itemOrId: file, fromViewer: true });
    }, [file]);

    const content = useMemo(() => {
        if (isArchive(file) && isPreviewableFile) {
            // FIXME: Тут нужно будет сделать отдельный компонент для мобильного просмотра архивов когда будут дизайны.
            return (
                <ViewerArchiveConnected
                    file={file}
                    storage={storage}
                    sendGa={(action, label) => sendXray(['indpnewv-public', action, label])}
                    isPhone={true}
                    embedded={true}
                />
            );
        }
        return (
            <MobileViewerItem
                isPublic
                itemId={file.id}
                isSingle={true}
                handleDownload={handleDownload}
                storage={storage}
                isViewContentOnly={isViewContentOnly}
            />
        );
    }, [handleDownload, file, isPreviewableFile]);

    return (
        <div className={styles.root}>
            <div className={styles.content}>{content}</div>
        </div>
    );
});

PublicFile.displayName = 'PublicFile';
